module.exports = __webpack_public_path__ + "media/images/levelup_crown_bronze-a6251910c1cdaea3ad1a56bd12feffbd.png";